import React, { useState } from "react";
// import { Menu } from "../Menu/Menu";
import { motion, useMotionValueEvent, useScroll } from "motion/react";

export const Navbar: React.FC = () => {
  const [navbarVisible, setNavbarVisible] = useState(false);

  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (current) => {
    let prev = 0;
    if (scrollY.getPrevious !== undefined) {
      prev = scrollY.getPrevious()!;
    }

    // Hide navbar in Hero Section
    if (current < 750) {
      setNavbarVisible(false);
      return;
    } else {
      // Show navbar when scrolling up
      if (current - prev > 0) {
        setNavbarVisible(false);
      } else {
        setNavbarVisible(true);
      }
    }
  });

  const navbarVariants = {
    hidden: { y: -100 },
    visible: { y: 0 },
  };
  return (
    <motion.nav
      className={`fixed top-0 w-full h-fit py-4 px-10 flex justify-center z-50 transition-opacity duration-500 `}
      initial={navbarVisible ? "visible" : "hidden"}
      animate={navbarVisible ? "visible" : "hidden"}
      variants={navbarVariants}
      transition={{
        duration: 0.5,
        ease: "easeInOut",
        type: "spring",
        damping: 20,
        stiffness: 250,
        mass: 0.1,
      }}
    >
      <div className=" absolute w-full h-full top-0 left-0 backdrop-blur-lg"></div>
      <img
        src="/logo/logo.svg"
        alt="logo"
        className={`h-8 md:h-10 z-50`}
        onClick={() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
          window.location.href = "/";
        }}
      />
      {/* <Menu /> */}
    </motion.nav>
  );
};
